import { Box, Stack, TableCell, Typography } from "@mui/material"
import { ChipList, TinyChip } from "@pharmupp/p3-front-commons"
import { ArrowRight } from "react-feather"
import { OperationStateEnum } from "../../AdherentMarketingOperations"
import type { ReferentialLaboratory } from "../../types"

type OperationCellProps = {
  partnerLaboratories?: ReferentialLaboratory[]
  name: string
  state?: OperationStateEnum
  hidden?: boolean
} & (
  | { startDate?: string; endDate?: string; date?: never }
  | { startDate?: never; endDate?: never; date?: string }
)

export const OperationCell = ({
  partnerLaboratories = [],
  name,
  state,
  startDate,
  endDate,
  date,
  hidden,
}: OperationCellProps) => {
  const partnerLabChipList = partnerLaboratories.map((lab) => ({ label: lab.name }))
  return (
    <TableCell>
      <Stack
        fontSize={({ typography }) => typography.pxToRem(12)}
        color={hidden ? "grey.light" : "common.darkBlue"}
        spacing={1}
      >
        <Stack direction="row" gap={1}>
          <ChipList
            ChipElement={TinyChip}
            chips={partnerLabChipList}
            maxChipsCount={2}
            defaultChipProps={{
              variation: hidden ? "bordered-greyLight" : "default",
            }}
          />
        </Stack>
        <Typography fontSize="inherit" fontWeight={600}>
          {name}
        </Typography>
        {startDate && endDate && (
          <Box display="flex" alignItems="center" gap={0.5}>
            <Typography
              fontSize="inherit"
              color={
                state === OperationStateEnum.OUTDATED ? "error.main" : "inherit"
              }
            >
              {startDate}
            </Typography>
            <ArrowRight size="13px" style={{ marginTop: "-2px" }} />
            <Typography
              fontSize="inherit"
              color={
                state === OperationStateEnum.OUTDATED ? "error.main" : "inherit"
              }
            >
              {endDate}
            </Typography>
          </Box>
        )}
        {date && (
          <Box display="flex" alignItems="center">
            <Typography fontSize="inherit" color="inherit">
              {date}
            </Typography>
          </Box>
        )}
      </Stack>
    </TableCell>
  )
}
